export const CHAT_DISABLED_SECOND_WINDOW =
    "Chat has been disabled here because you have enabled chat in a second window.";
